import { Turbo } from "@hotwired/turbo-rails"

Turbo.StreamActions.fetch_stream = async function () {
  const url = this.getAttribute("url")
  if (!url || new URL(url, window.location.origin).origin !== window.location.origin) return

  const requestingPage = document.body
  const response = await fetch(url, { headers: { Accept: "text/vnd.turbo-stream.html" } })
  if (!response.ok || document.body !== requestingPage) return

  Turbo.renderStreamMessage(await response.text())
}
